import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Link, Text, VStack } from '@chakra-ui/react'
import { REGISTER_SCHEMA_STEP_THREE, RegisterStepThreeType, useRegisterStep } from 'context/Register'
import { Formik } from 'formik'

import { InputControl, SubmitButton } from 'components/InputCustom'
import { CheckboxControl } from 'components/InputCustom/CheckboxControl'
import { customToast } from 'components/ToastCustom'


export const StepThree = () => {
  const navigation = useNavigate()
  const {
    prevStep,
    stepThreeDispatch,
    clearError,
    registerStepState: {
      error,
      loading,
      state: {
        registerMock: { email, password, confirmPassword, phone },
      },
    },
  } = useRegisterStep()

  const initialValues: RegisterStepThreeType = {
    password: password ? password : '',
    confirmPassword: confirmPassword ? confirmPassword : '',
    acceptConditions: false,
  }

  useEffect(() => {
    if (error)
      customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  const handleOnSubmit = async ({
    password,
    confirmPassword,
    acceptConditions,
  }: RegisterStepThreeType) => {
    clearError()

    const { success, message } = await stepThreeDispatch({
      password,
      confirmPassword,
      acceptConditions,
    })

    if (!success)
      customToast.showToast({ description: message, title: 'Ups' })

    if (success)
      navigation('/validate-user', {
        state: {
          validateUser: {
            isLogin: false,
            user: {
              email,
              password,
              phoneNumber: `+569${phone}`
            },
          }
        }
      })
  }

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={REGISTER_SCHEMA_STEP_THREE}>
      <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
        <InputControl
          inputType='password'
          inputProps={{ placeholder: 'Ingresar contraseña', maxLength: 50 }}
          name='password'
          label='Contraseña'
          isDisabled={loading}
        />
        <InputControl
          inputType='password'
          inputProps={{ placeholder: 'Confirmar contraseña', maxLength: 50 }}
          name='confirmPassword'
          label='Confirmar contraseña'
          isDisabled={loading}
        />
        <CheckboxControl name='acceptConditions' isDisabled={loading}>
          <Text>
            Acepto los <Link textDecoration='underline' href='https://www.wicar.cl/terminos-y-condiciones/'>
              términos y condiciones</Link>
          </Text>
        </CheckboxControl>
        <SubmitButton
          w={'full'}
          isLoading={loading}
          loadingText="Creando cuenta... ">
          Crear Cuenta
        </SubmitButton>
        <Button
          w={'full'}
          variant={'secondary'}
          onClick={() => prevStep()}>
          Volver
        </Button>
      </VStack>
    </Formik>
  )
}
